<template>
    <p class="pb2-hint">
        <Icon icon="phosphor/regular/lightbulb" class="pb2-hint__icon size-3" aria-hidden="true" />
        <span class="pb2-hint__text">{{ text }}</span>
        <button type="button" class="pb2-hint__close" :aria-label="t('dismiss')" @click="emit('dismiss')">
            <Icon icon="phosphor/regular/x" class="size-3" />
        </button>
    </p>
</template>

<script setup lang="ts">
import { useBuilderT } from '@src/Common/Builder/host';

defineProps<{ text: string }>();

const emit = defineEmits<{ dismiss: [] }>();

const t = useBuilderT();
</script>

<style scoped>
.pb2-hint {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    margin: 0;
    padding: 0.25rem 0.3125rem;
    font-size: 0.6875rem;
    line-height: 1.35;
    color: var(--pb2-muted, #a1a1aa);
    background: color-mix(in srgb, var(--pb2-border, #e4e4e7) 30%, transparent);
    border-radius: 4px;
}

.pb2-hint__icon {
    flex-shrink: 0;
    color: color-mix(in srgb, var(--pb2-muted, #a1a1aa) 80%, transparent);
}

.pb2-hint__text {
    flex: 1;
    min-width: 0;
}

.pb2-hint__close {
    display: grid;
    place-items: center;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    color: var(--pb2-muted, #a1a1aa);
    background: none;
    border: 0;
    border-radius: 3px;
    cursor: pointer;
    transition: color 140ms ease;
}

.pb2-hint__close:hover {
    color: var(--pb2-text, #3f3f46);
}
</style>
